import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'readNotificationSeqNos';

interface NotificationReadContextType {
  readSeqNos: number[];
  markAllAsRead: (seqNos: number[]) => void;
}

const NotificationReadContext = createContext<NotificationReadContextType | undefined>(undefined);

export const NotificationReadProvider = ({ children }: { children: React.ReactNode }) => {
  const [readSeqNos, setReadSeqNos] = useState<number[]>([]);

  useEffect(() => {
    const fromStorage = localStorage.getItem(STORAGE_KEY);
    if (fromStorage) {
      setReadSeqNos(JSON.parse(fromStorage));
    }
  }, []);

  const markAllAsRead = (seqNos: number[]) => {
    const merged = Array.from(new Set([...readSeqNos, ...seqNos]));
    setReadSeqNos(merged);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  };

  return (
    <NotificationReadContext.Provider value={{ readSeqNos, markAllAsRead }}>
      {children}
    </NotificationReadContext.Provider>
  );
};

export const useNotificationRead = () => {
  const ctx = useContext(NotificationReadContext);
  if (!ctx) throw new Error('useNotificationRead must be used within NotificationReadProvider');
  return ctx;
};
